export const APISERVERURL='https://api.bhattadevapp.nirupan.org'
